export const programsColumns = [
  { key: 'name', label: 'Program Name' },
  { key: 'gender', label: 'Gender' },
  { key: 'sport', label: 'Sport' },
  { key: 'userLevel', label: 'User Level' },
  { key: 'category', label: 'Category' },
  { key: 'material', label: 'Material' },
  { key: 'specialProgram', label: 'Special Program' },
  { key: 'status', label: 'Status' },
  { key: 'date', label: 'Last Update Date' },
];

export const constrainedProgramsColumns = [
	{ key: 'id', label: 'ID' },
	{ key: 'name', label: 'Program Base Name' },
  { key: 'date', label: 'Last Update Date' },
]

export const exercisesColumns = [
  { key: 'name', label: 'Generic Name' },
  { key: 'update', label: 'Last Update' }
];

export const workoutsColumns = [
  { key: 'name', label: 'Workout Name' },
  { key: 'sport', label: 'Sport' },
  { key: 'focus', label: 'Focus' },
  { key: 'flag', label: 'Flag' },
  { key: 'status', label: 'Status' },
  { key: 'update', label: 'Last Update' }
];